var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height flex-column",staticStyle:{"overflow-y":"auto","overflow-x":"hidden"},attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('card-title-row',{class:{ 'pt-5': !_vm.isCardInfoPrint },attrs:{"translation-path":"sidebar.locks.locksAnalysis","has-button":false}}),_c('locks-analysis-tool')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }